export function onAddShiftUpdate(cache) {
    var scheduleIdentifier = cache.identify({
        __typename: 'Schedule'
    });
    cache.evict({ id: scheduleIdentifier });
    var shiftOpportunitiesIdentifier = cache.identify({
        __typename: 'ShiftOpportunities'
    });
    cache.evict({ id: shiftOpportunitiesIdentifier });
    cache.gc();
}
